/**
 * Running a local relay server will allow you to hide your API key
 * and run custom logic on the server
 *
 * Set the local relay server address to:
 * REACT_APP_LOCAL_RELAY_SERVER_URL=http://localhost:8081
 *
 * This will also require you to set OPENAI_API_KEY= in a `.env` file
 * You can run it with `npm run relay`, in parallel with `npm start`
 */
const LOCAL_RELAY_SERVER_URL: string =
  process.env.REACT_APP_LOCAL_RELAY_SERVER_URL || '';

const TEMP_URL_1: string =
  process.env.TEMP_URL || '';

import { useEffect, useRef, useCallback, useState } from 'react';
// @ts-ignore
import { RealtimeClient } from '@openai/realtime-api-beta';
// @ts-ignore
import { ItemType } from '@openai/realtime-api-beta/dist/lib/client.js';
import { WavRecorder, WavStreamPlayer } from '../lib/wavtools/index.js';
import { instructions } from '../utils/conversation_config.js';
import { WavRenderer } from '../utils/wav_renderer';

import { X, Edit, Zap, ArrowUp, ArrowDown } from 'react-feather';
import { Button } from '../components/button/Button';
import { Toggle } from '../components/toggle/Toggle';
import { Map } from '../components/Map';

import './ConsolePage.scss';
// import './Profile.scss'
import { isJsxOpeningLikeElement } from 'typescript';
import imgicon from '../assets/Group970.svg'
import UserComment from './userComment';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig.js';
import { useLocation, useNavigate } from 'react-router-dom';
/**
 * Type for result from get_weather() function call
 */
interface Coordinates {
  lat: number;
  lng: number;
  location?: string;
  temperature?: {
    value: number;
    units: string;
  };
  wind_speed?: {
    value: number;
    units: string;
  };
}

/**
 * Type for all event logs
 */
interface RealtimeEvent {
  time: string;
  source: 'client' | 'server';
  count?: number;
  event: { [key: string]: any };
}

export function ConsolePage() {
  /**
   * Ask user for API Key
   * If we're using the local relay server, we don't need this
   */
  
  const apiKey = LOCAL_RELAY_SERVER_URL || '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'
    ? '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'
    : localStorage.getItem('tmp::voice_api_key') ||
      prompt('OpenAI API Key') ||
      '';
  if (apiKey !== '') {
    localStorage.setItem('tmp::voice_api_key', apiKey);
  }
  /**
   * Instantiate:
   * - WavRecorder (speech input)
   * - WavStreamPlayer (speech output)
   * - RealtimeClient (API client)
   */
  const wavRecorderRef = useRef<WavRecorder>(
    new WavRecorder({ sampleRate: 24000 })
  );
  const wavStreamPlayerRef = useRef<WavStreamPlayer>(
    new WavStreamPlayer({ sampleRate: 24000 })
  );
  const clientRef = useRef<RealtimeClient>(
    new RealtimeClient(
      LOCAL_RELAY_SERVER_URL
        ? { url: LOCAL_RELAY_SERVER_URL }
        : {
            apiKey: apiKey,
            dangerouslyAllowAPIKeyInBrowser: true,
          }
    )
  );

  /**
   * References for
   * - Rendering audio visualization (canvas)
   * - Autoscrolling event logs
   * - Timing delta for event log displays
   */
  const clientCanvasRef = useRef<HTMLCanvasElement>(null);
  const serverCanvasRef = useRef<HTMLCanvasElement>(null);
  const eventsScrollHeightRef = useRef(0);
  const eventsScrollRef = useRef<HTMLDivElement>(null);
  const startTimeRef = useRef<string>(new Date().toISOString());
  const [isModalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate(); 
  const location = useLocation(); // Get location and state
  // const users = location.state?.user as User | any;
  const userInfo = localStorage.getItem('userinfo') as any;

  // console.log(userInfo,'users')
  /**
   * All of our variables for displaying application state
   * - items are all conversation items (dialog)
   * - realtimeEvents are event logs, which can be expanded
   * - memoryKv is for set_memory() function
   * - coords, marker are for get_weather() function
   */
  const [items, setItems] = useState<ItemType[]>([]);
  const [realtimeEvents, setRealtimeEvents] = useState<RealtimeEvent[]>([]);
  const [expandedEvents, setExpandedEvents] = useState<{
    [key: string]: boolean;
  }>({});
  const [isConnected, setIsConnected] = useState(false);
  const [canPushToTalk, setCanPushToTalk] = useState(true);
  const [isRecording, setIsRecording] = useState(false);
  const [memoryKv, setMemoryKv] = useState<{ [key: string]: any }>({});
  const [coords, setCoords] = useState<Coordinates | null>({
    lat: 37.775593,
    lng: -122.418137,
  });
  const [marker, setMarker] = useState<Coordinates | null>(null);

  const [minutes, setMinutes] = useState<number>(1); 
  const [seconds, setSeconds] = useState<number>(11);
  const [user, setUser] = useState< null>(null);
  const timerRef = useRef<any>(null);
  const lastElapsedTimeRef = useRef({ minutes: 1, seconds: 0 });
  const timeRef = useRef({
    minutes: 1,
    seconds: 0,
  });
  const timerFinishedRef = useRef(false); 
  const DAILY_LIMIT_MIN = 3;
// history state
  const [responseMessage, setResponseMessage] = useState<string | null>(null);
  var userDetail = JSON.parse(userInfo);
 
  useEffect(()=>{
    const userinfoString = localStorage.getItem("userinfo");
    if(!userinfoString){
      window.location.href = "/";
      return;
    }
  },[])

  const handleSaveHistory = async (useDate: any , useTime: any) => {
    const url = "https://talk.dil.in/api/user_history.php";

    // Prepare the data to be sent in the POST request
    const data = {
      user_id: userDetail.userId,
      use_date: useDate,
      use_time: useTime,
    };

    try {
      // Send the POST request
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",  // Set the content type as JSON
        },
        body: JSON.stringify(data),  // Convert the data to JSON
      });

      // Parse the JSON response
      const result = await response.json();

      if (result.status === 1) {
        setResponseMessage(result.message);  // Show success message
      } else {
        setResponseMessage(`Error: ${result.message}`);  // Show error message
      }
    } catch (error) {
      setResponseMessage(`Request failed: ${error}`);  // Show error if request fails
      console.error("Error during request:", error);
    }
  };

  // Start the timer from scratch (5 minutes)
  const formatTime1  = (time: number) => (time < 10 ? `0${time}` : time);
  // Start or resume the countdown timer from the current saved time

  const startTimer = () => {
    const DAILY_LIMIT = DAILY_LIMIT_MIN * 60; // 5 minutes in seconds
    const savedData = JSON.parse(localStorage.getItem('timerState')+"");
    
    let initialMinutes = DAILY_LIMIT_MIN; // Start with the full 5-minute limit
    let initialSeconds = 0;
    let timeUsedToday = 0;
    
    // Check if there's saved data and if it's for today
    const today = new Date().toISOString().slice(0, 10); // Get current date (YYYY-MM-DD)
    if (savedData && savedData.date === today) {
      timeUsedToday = savedData.timeUsed || 0;
      const remainingTime = Math.max(DAILY_LIMIT - timeUsedToday, 0);
      initialMinutes = Math.floor(remainingTime / 60);
      initialSeconds = remainingTime % 60;
    } else {
      // Reset usage if it's a new day
      timeUsedToday = 0;
      // localStorage.setItem(
      //   'timerState',
      //   JSON.stringify({ date: today, timeUsed: 0 })
      // );
    }
  
    // If timeUsedToday has already exceeded the daily limit, stop the timer
    if (timeUsedToday >= DAILY_LIMIT) {
      alert("You have used up your "+DAILY_LIMIT_MIN+"-minute limit for today.");
      return false;
    }
  
    // Set the initial time
    timeRef.current = { minutes: initialMinutes, seconds: initialSeconds };
    setMinutes(initialMinutes);
    setSeconds(initialSeconds);
  
    // Clear any previous timers
    if (timerRef.current) clearInterval(timerRef.current);
  
    // Start the countdown
    timerRef.current = setInterval(() => {
      // Check if the timer has reached 00:00
      if (timeRef.current.minutes === 0 && timeRef.current.seconds === 0) {
        clearInterval(timerRef.current); // Stop the timer
        timerFinishedRef.current = true; // Set the timer as finished
        return false;
      }
  
      // Decrement seconds and manage minute transitions
      if (timeRef.current.seconds === 0) {
        timeRef.current.minutes -= 1;
        timeRef.current.seconds = 59;
      } else {
        timeRef.current.seconds -= 1;
      }
  
      // Update the state values to reflect the new time
      setMinutes(timeRef.current.minutes);
      setSeconds(timeRef.current.seconds);
  
      // Update time used for today and save to localStorage
      timeUsedToday += 1;
      localStorage.setItem(
        'timerState',
        JSON.stringify({
          date: today,
          timeUsed: timeUsedToday,
        })
      );

      handleSaveHistory(today, timeUsedToday);
  
      // Stop the timer if the daily limit is reached
      if (timeUsedToday >= DAILY_LIMIT) {
        disconnectConversation();
        alert("You have reached your "+DAILY_LIMIT_MIN+"-minute limit for today.");
        clearInterval(timerRef.current);
        timeRef.current = { minutes: 0, seconds: 0 };
        setMinutes(0);
        setSeconds(0);
      }
    }, 1000); // Runs every second
  
    return true;
  };  

  // Stop the timer and save the current time
  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current); // Stop the timer
      timerFinishedRef.current = false; // Reset the "finished" flag when disconnected
      // Save the current time to localStorage when paused
      // localStorage.setItem(
      //   'timerState',
      //   JSON.stringify({ minutes, seconds })
      // );
    }
  };

  /**
   * Utility for formatting the timing of logs
   */
  const formatTime = useCallback((timestamp: string) => {
    const startTime = startTimeRef.current;
    const t0 = new Date(startTime).valueOf();
    const t1 = new Date(timestamp).valueOf();
    const delta = t1 - t0;
    const hs = Math.floor(delta / 10) % 100;
    const s = Math.floor(delta / 1000) % 60;
    const m = Math.floor(delta / 60_000) % 60;
    const pad = (n: number) => {
      let s = n + '';
      while (s.length < 2) {
        s = '0' + s;
      }
      return s;
    };
    return `${pad(m)}:${pad(s)}.${pad(hs)}`;
  }, []);

  /**
   * When you click the API key
   */
  const resetAPIKey = useCallback(() => {
    const apiKey = prompt('OpenAI API Key');
    if (apiKey !== null) {
      localStorage.clear();
      localStorage.setItem('tmp::voice_api_key', apiKey);
      window.location.reload();
    }
  }, []);

  /**
   * Connect to conversation:
   * WavRecorder taks speech input, WavStreamPlayer output, client is API client
   */
  const connectConversation = useCallback(async () => {
    // Start the timer from scratch (5 minutes)
    if(!startTimer()) {
      return;
    }

    const client = clientRef.current;
    const wavRecorder = wavRecorderRef.current;
    const wavStreamPlayer = wavStreamPlayerRef.current;

    // Set state variables
    startTimeRef.current = new Date().toISOString();
    setIsConnected(true);
    setRealtimeEvents([]);
    setItems(client.conversation.getItems());

    // Connect to microphone
    await wavRecorder.begin();

    // Connect to audio output
    await wavStreamPlayer.connect();

    // Connect to realtime API
    await client.connect();
    client.sendUserMessageContent([
      {
        type: `input_text`,
        text: `Hello!`,
        // text: `For testing purposes, I want you to list ten car brands. Number each item, e.g. "one (or whatever number you are one): the item name".`
      },
    ]);

    if (client.getTurnDetectionType() === 'server_vad') {
      await wavRecorder.record((data) => client.appendInputAudio(data.mono));
    }

    // setTimeout(() => {
    //   changeTurnEndType('server_vad');
    // }, 5000); // 5000 milliseconds = 5 seconds
  }, []);

  /**
   * Disconnect and reset conversation state
   */
  const disconnectConversation = useCallback(async () => {
    setIsConnected(false);
    setRealtimeEvents([]);
    setItems([]);
    setMemoryKv({});
    setCoords({
      lat: 37.775593,
      lng: -122.418137,
    });
    setMarker(null);

    //setModalVisible(true);
    // Stop the timer and save the current time
    stopTimer();

    const client = clientRef.current;
    client.disconnect();

    const wavRecorder = wavRecorderRef.current;
    await wavRecorder.end();

    const wavStreamPlayer = wavStreamPlayerRef.current;
    await wavStreamPlayer.interrupt();
  }, [minutes, seconds]);

  const deleteConversationItem = useCallback(async (id: string) => {
    const client = clientRef.current;
    client.deleteItem(id);
  }, []);

  // On component mount, check if there's any saved timer state in localStorage
  useEffect(() => {
    // Ensure the timer starts from 5 minutes if no saved state is found
    const savedTime = localStorage.getItem('timerState');
    if (!savedTime || savedTime === '{"minutes":0,"seconds":0}') {
      // If timer has reached 00:00 before, reset to starting point (5:00)
      setMinutes(1);
      setSeconds(0);
      timeRef.current = { minutes: 1, seconds: 0 };
      localStorage.setItem(
        'timerState',
        JSON.stringify({ minutes: 1, seconds: 0 })
      );
    } else {
      // If there's saved time, load it
      const { minutes, seconds } = JSON.parse(savedTime);
      setMinutes(minutes);
      setSeconds(seconds);
      timeRef.current = { minutes, seconds };
    }
  }, []);

  /**
   * In push-to-talk mode, start recording
   * .appendInputAudio() for each sample
   */
  const startRecording = async () => {
    setIsRecording(true);
    const client = clientRef.current;
    const wavRecorder = wavRecorderRef.current;
    const wavStreamPlayer = wavStreamPlayerRef.current;
    const trackSampleOffset = await wavStreamPlayer.interrupt();
    if (trackSampleOffset?.trackId) {
      const { trackId, offset } = trackSampleOffset;
      await client.cancelResponse(trackId, offset);
    }
    await wavRecorder.record((data) => client.appendInputAudio(data.mono));
  };

  /**
   * In push-to-talk mode, stop recording
   */
  const stopRecording = async () => {
    setIsRecording(false);
    const client = clientRef.current;
    const wavRecorder = wavRecorderRef.current;
    await wavRecorder.pause();
    client.createResponse();
  };

  /**
   * Switch between Manual <> VAD mode for communication
   */
  const changeTurnEndType = async (value: string) => {
    const client = clientRef.current;
    const wavRecorder = wavRecorderRef.current;
    if (value === 'none' && wavRecorder.getStatus() === 'recording') {
      await wavRecorder.pause();
    }
    client.updateSession({
      turn_detection: value === 'none' ? null : { type: 'server_vad' },
    });
    if (value === 'server_vad' && client.isConnected()) {
      await wavRecorder.record((data) => client.appendInputAudio(data.mono));
    }
    setCanPushToTalk(value === 'none');
  };

  /**
   * Auto-scroll the event logs
   */
  useEffect(() => {
    if (eventsScrollRef.current) {
      const eventsEl = eventsScrollRef.current;
      const scrollHeight = eventsEl.scrollHeight;
      // Only scroll if height has just changed
      if (scrollHeight !== eventsScrollHeightRef.current) {
        eventsEl.scrollTop = scrollHeight;
        eventsScrollHeightRef.current = scrollHeight;
      }
    }
  }, [realtimeEvents]);

  /**
   * Auto-scroll the conversation logs
   */
  useEffect(() => {
    const conversationEls = [].slice.call(
      document.body.querySelectorAll('[data-conversation-content]')
    );
    for (const el of conversationEls) {
      const conversationEl = el as HTMLDivElement;
      conversationEl.scrollTop = conversationEl.scrollHeight;
    }
  }, [items]);

  /**
   * Set up render loops for the visualization canvas
   */
  useEffect(() => {
    let isLoaded = true;

    const wavRecorder = wavRecorderRef.current;
    const clientCanvas = clientCanvasRef.current;
    let clientCtx: CanvasRenderingContext2D | null = null;

    const wavStreamPlayer = wavStreamPlayerRef.current;
    const serverCanvas = serverCanvasRef.current;
    let serverCtx: CanvasRenderingContext2D | null = null;

    const render = () => {
      if (isLoaded) {
        if (clientCanvas) {
          if (!clientCanvas.width || !clientCanvas.height) {
            clientCanvas.width = clientCanvas.offsetWidth;
            clientCanvas.height = clientCanvas.offsetHeight;
          }
          clientCtx = clientCtx || clientCanvas.getContext('2d');
          if (clientCtx) {
            clientCtx.clearRect(0, 0, clientCanvas.width, clientCanvas.height);
            const result = wavRecorder.recording
              ? wavRecorder.getFrequencies('voice')
              : { values: new Float32Array([0]) };
            WavRenderer.drawBars(
              clientCanvas,
              clientCtx,
              result.values,
              '#0099ff',
              10,
              0,
              8
            );
          }
        }
        if (serverCanvas) {
          if (!serverCanvas.width || !serverCanvas.height) {
            serverCanvas.width = serverCanvas.offsetWidth;
            serverCanvas.height = serverCanvas.offsetHeight;
          }
          serverCtx = serverCtx || serverCanvas.getContext('2d');
          if (serverCtx) {
            serverCtx.clearRect(0, 0, serverCanvas.width, serverCanvas.height);
            const result = wavStreamPlayer.analyser
              ? wavStreamPlayer.getFrequencies('voice')
              : { values: new Float32Array([0]) };
            WavRenderer.drawBars(
              serverCanvas,
              serverCtx,
              result.values,
              '#009900',
              10,
              0,
              8
            );
          }
        }
        window.requestAnimationFrame(render);
      }
    };
    render();

    return () => {
      isLoaded = false;
    };
  }, []);

  /**
   * Core RealtimeClient and audio capture setup
   * Set all of our instructions, tools, events and more
   */
  useEffect(() => {
    // Get refs
    const wavStreamPlayer = wavStreamPlayerRef.current;
    const client = clientRef.current;

    // Set instructions
    client.updateSession({ instructions: instructions });
    // Set transcription, otherwise we don't get user transcriptions back
    client.updateSession({ input_audio_transcription: { model: 'whisper-1' } });

    // Add tools
    client.addTool(
      {
        name: 'set_memory',
        description: 'Saves important data about the user into memory.',
        parameters: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              description:
                'The key of the memory value. Always use lowercase and underscores, no other characters.',
            },
            value: {
              type: 'string',
              description: 'Value can be anything represented as a string',
            },
          },
          required: ['key', 'value'],
        },
      },
      async ({ key, value }: { [key: string]: any }) => {
         setMemoryKv((memoryKv) => {
           const newKv = { ...memoryKv };
           newKv[key] = value;
           return newKv;
         });
         return { ok: true };
      }
    );
    // client.addTool(
    // {
    //   "name": "getRajasthanData",
    //   "description": "Fetches information specific to Rajasthan.",
    //   "parameters": {
    //     "type": "object",
    //     "properties": {
    //       "topic": {
    //         "type": "string",
    //         "description": "The subject matter related to Rajasthan."
    //       }
    //     },
    //     "required": ["topic"]
    //   }
    // },
    //   async ({ key, value }: { [key: string]: any }) => {
    //     setMemoryKv((memoryKv) => {
    //       const newKv = { ...memoryKv };
    //       newKv[key] = value;
    //       return newKv;
    //     });
    //     return { ok: true };
    //   }
    // );
    // client.addTool(
    //   {
    //     name: 'get_weather',
    //     description:
    //       'Retrieves the weather for a given lat, lng coordinate pair. Specify a label for the location.',
    //     parameters: {
    //       type: 'object',
    //       properties: {
    //         lat: {
    //           type: 'number',
    //           description: 'Latitude',
    //         },
    //         lng: {
    //           type: 'number',
    //           description: 'Longitude',
    //         },
    //         location: {
    //           type: 'string',
    //           description: 'Name of the location',
    //         },
    //       },
    //       required: ['lat', 'lng', 'location'],
    //     },
    //   },
    //   async ({ lat, lng, location }: { [key: string]: any }) => {
    //     setMarker({ lat, lng, location });
    //     setCoords({ lat, lng, location });
    //     const result = await fetch(
    //       `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,wind_speed_10m`
    //     );
    //     const json = await result.json();
    //     const temperature = {
    //       value: json.current.temperature_2m as number,
    //       units: json.current_units.temperature_2m as string,
    //     };
    //     const wind_speed = {
    //       value: json.current.wind_speed_10m as number,
    //       units: json.current_units.wind_speed_10m as string,
    //     };
    //     setMarker({ lat, lng, location, temperature, wind_speed });
    //     return json;
    //   }
    // );

    // handle realtime events from client + server for event logging
    client.on('realtime.event', (realtimeEvent: RealtimeEvent) => {
      setRealtimeEvents((realtimeEvents) => {
        const lastEvent = realtimeEvents[realtimeEvents.length - 1];
        if (lastEvent?.event.type === realtimeEvent.event.type) {
          // if we receive multiple events in a row, aggregate them for display purposes
          lastEvent.count = (lastEvent.count || 0) + 1;
          return realtimeEvents.slice(0, -1).concat(lastEvent);
        } else {
          return realtimeEvents.concat(realtimeEvent);
        }
      });
    });
    client.on('error', (event: any) => console.error(event));
    client.on('conversation.interrupted', async () => {
      const trackSampleOffset = await wavStreamPlayer.interrupt();
      if (trackSampleOffset?.trackId) {
        const { trackId, offset } = trackSampleOffset;
        await client.cancelResponse(trackId, offset);
      }
    });
    client.on('conversation.updated', async ({ item, delta }: any) => {
      const items = client.conversation.getItems();
      if (delta?.audio) {
        wavStreamPlayer.add16BitPCM(delta.audio, item.id);
      }
      if (item.status === 'completed' && item.formatted.audio?.length) {
        const wavFile = await WavRecorder.decode(
          item.formatted.audio,
          24000,
          24000
        );
        item.formatted.file = wavFile;
      }
      setItems(items);
    });

    setItems(client.conversation.getItems());

    return () => {
      // cleanup; resets to defaults
      client.reset();
    };
  }, []);

  const userCommentOpen = () => {
    setModalVisible(true); // Show the modal
  };

  const handleClose = () => {
    setModalVisible(false); // Hide the modal
  };

  useEffect(() => {
    changeTurnEndType('server_vad'); // Set initial value

    const DAILY_LIMIT = DAILY_LIMIT_MIN * 60; // 5 minutes in seconds
    const savedData = JSON.parse(localStorage.getItem('timerState')+"");
    
    let initialMinutes = DAILY_LIMIT_MIN; // Start with the full 5-minute limit
    let initialSeconds = 0;
    let timeUsedToday = 0;
    
    const today = new Date().toISOString().slice(0, 10); // Get current date (YYYY-MM-DD)
    if (savedData && savedData.date === today) {
      timeUsedToday = savedData.timeUsed || 0;
      const remainingTime = Math.max(DAILY_LIMIT - timeUsedToday, 0);
      initialMinutes = Math.floor(remainingTime / 60);
      initialSeconds = remainingTime % 60;
    }

    timeRef.current = { minutes: initialMinutes, seconds: initialSeconds };
    setMinutes(initialMinutes);
    setSeconds(initialSeconds);
  }, []);

  /**
   * Render the application
   */
  const HandleLogout =async ()=>{
    
    try {
      localStorage.removeItem("timerState")
      localStorage.removeItem("userinfo")
      sessionStorage.clear();
      window.location.href = "/";
      setUser(null);
    } catch (error) {
      console.error("Error during Logout:", error);
    }
    setUser(null)
}
  return (
    <div data-component="ConsolePage">
      <div className="content-top">
        <div className="content-title">
          <div style={{display:'flex', alignItems: 'center', gap: '6px'}}>
          <img src={imgicon}/>
          <span>Your virtual guide for Rajasthan (Beta)</span>
          </div>
          <div className="right-4 flex items-center space-x-4">
 
  <button className="bg-gray-800 text-white px-4 py-2 rounded-lg flex items-center hover:bg-gray-700">
    <span className="mr-2" title={userDetail?.email}>{userDetail?.name}</span>
  </button>

  
  <button
    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-500"
    onClick={HandleLogout}
  >
    Logout
  </button>
</div>


        </div>
    
        <div className="content-api-key" style={{ display: 'none' }}>
          {!LOCAL_RELAY_SERVER_URL && (
            <Button
              icon={Edit}
              iconPosition="end"
              buttonStyle="flush"
              label={`api key: ${apiKey.slice(0, 3)}...`}
              onClick={() => resetAPIKey()}
            />
          )}
        </div>
        
      </div>
      <div className="content-main">
        <div className="content-logs">
          <div className="content-block events" style = {{display: 'none'}}>
            {/* <div className="visualization">
              <div className="visualization-entry client">
                <canvas ref={clientCanvasRef} />
              </div>
              <div className="visualization-entry server">
                <canvas ref={serverCanvasRef} />
              </div>
            </div> */}
            <div className="content-block-title">Events</div>
            <div className="content-block-body" ref={eventsScrollRef}  style={{display:"none"}}>
              {!realtimeEvents.length && `awaiting connection...`}
              {realtimeEvents.map((realtimeEvent, i) => {
                const count = realtimeEvent.count;
                const event = { ...realtimeEvent.event };
                if (event.type === 'input_audio_buffer.append') {
                  event.audio = `[trimmed: ${event.audio.length} bytes]`;
                } else if (event.type === 'response.audio.delta') {
                  event.delta = `[trimmed: ${event.delta.length} bytes]`;
                }
                return (
                  <div className="event" key={event.event_id}>
                    <div className="event-timestamp">
                      {formatTime(realtimeEvent.time)}
                    </div>
                    <div className="event-details">
                      <div
                        className="event-summary"
                        onClick={() => {
                          // toggle event details
                          const id = event.event_id;
                          const expanded = { ...expandedEvents };
                          if (expanded[id]) {
                            delete expanded[id];
                          } else {
                            expanded[id] = true;
                          }
                          setExpandedEvents(expanded);
                        }}
                      >
                        <div
                          className={`event-source ${
                            event.type === 'error'
                              ? 'error'
                              : realtimeEvent.source
                          }`}
                        >
                          {realtimeEvent.source === 'client' ? (
                            <ArrowUp />
                          ) : (
                            <ArrowDown />
                          )}
                          <span>
                            {event.type === 'error'
                              ? 'error!'
                              : realtimeEvent.source}
                          </span>
                        </div>
                        <div className="event-type">
                          {event.type}
                          {count && ` (${count})`}
                        </div>
                      </div>
                      {!!expandedEvents[event.event_id] && (
                        <div className="event-payload">
                          {JSON.stringify(event, null, 2)}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="content-block conversation">
            <div className="content-block-title">Conversation</div>
            <div className="content-block-body" data-conversation-content>
              {!items.length && `Press Connect and Wait for the response. You will be able to Start the voice based Conversation...`}
              {items.map((conversationItem, i) => {
                return (
                  <div className="conversation-item" key={conversationItem.id}>
                    <div className={`speaker ${conversationItem.role || ''}`}>
                      <div>
                        {(
                          conversationItem.role=='user'?userDetail?.name:conversationItem.role || '' //conversationItem.type
                        ).replaceAll('_', ' ')}
                      </div>
                      <div
                        className="close"
                        onClick={() =>
                          deleteConversationItem(conversationItem.id)
                        }
                      >
                        <X />
                      </div>
                    </div>
                    <div className={`speaker-content`}>
                      {/* tool response */}
                      {/* {conversationItem.type === 'function_call_output' && (
                        <div>{conversationItem.formatted.output}</div>
                      )} */}
                      {/* tool call */}
                      {/* {!!conversationItem.formatted.tool && (
                        <div>
                          {conversationItem.formatted.tool.name}(
                          {conversationItem.formatted.tool.arguments})
                        </div>
                      )} */}
                      {!conversationItem.formatted.tool &&
                        conversationItem.role === 'user' && (
                          <div>
                            {conversationItem.formatted.transcript ||
                              (conversationItem.formatted.audio?.length
                                ? '(awaiting transcript)'
                                : conversationItem.formatted.text ||
                                  '(item sent)')}
                          </div>
                        )}
                      {!conversationItem.formatted.tool &&
                        conversationItem.role === 'assistant' && (
                          <div>
                            {conversationItem.formatted.transcript ||
                              conversationItem.formatted.text ||
                              '(truncated)'}
                          </div>
                        )}
                        {/* hide audio */}
                      {/* {conversationItem.formatted.file && (
                        <audio
                          src={conversationItem.formatted.file.url}
                          controls
                        />
                      )} */}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          
          <p>
          <div style={{float: 'right', color: 'red', position: 'relative', top: '10px', fontSize: '11px', marginRight: '6px'}}>Time Left: <span id="timer"></span>{formatTime1(minutes)}:{formatTime1(seconds)}</div>
            <span style={{display: 'inline-flex', alignItems: 'center', position: 'relative', top: '4px'}}><svg style={{width:'20px', position: 'relative'}} id="layer_1" enable-background="new 0 0 32 32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="m24.1884766 16.6132812c0 3.0322266-2.4677734 5.5-5.5 5.5h-5.3769531c-3.0322266 0-5.5-2.4677734-5.5-5.5v-1h-2v1c0 4.1357422 3.3642578 7.5 7.5 7.5h1.6884765v5.8867188h2v-5.8867188h1.6884766c4.1357422 0 7.5-3.3642578 7.5-7.5v-1h-2z"/><path d="m18.6884766 19.7802734c1.7460938 0 3.1669922-1.4208984 3.1669922-3.1669922v-11.446289c0-1.7460938-1.4208985-3.1669922-3.1669922-3.1669922h-5.3769531c-1.7460938 0-3.1669922 1.4208984-3.1669922 3.1669922v11.4462891c0 1.7460938 1.4208984 3.1669922 3.1669922 3.1669922h5.3769531z"/><path d="m5.812 4.89h2v8h-2z"/><path d="m24.188 4.89h2v8h-2z"/><path d="m27.188 6.89h2v4h-2z"/><path d="m2.812 6.89h2v4h-2z"/></svg> Mic</span>
          </p>
          
          <div className="content-actions">
            
            <Toggle
              defaultValue={true}
              labels={['Off', 'On']}
              values={['none', 'server_vad']}
              onChange={(_, value) => changeTurnEndType(value)}
            />
           <div className="visualization">
              <div className="visualization-entry client">
                <canvas ref={clientCanvasRef} />
              </div>
              <div className="visualization-entry server">
                <canvas ref={serverCanvasRef} />
              </div>
            </div>
            <div className="spacer" />
            {isConnected && canPushToTalk && (
              <Button
                label={isRecording ? 'release to send' : 'push to talk'}
                buttonStyle={isRecording ? 'alert' : 'regular'}
                disabled={!isConnected || !canPushToTalk}
                onMouseDown={startRecording}
                onMouseUp={stopRecording}
                style={{display:"none"}}
              />
            )}
            <div className="spacer" />
            <Button
              label={isConnected ? 'Disconnect' : 'Connect'}
              iconPosition={isConnected ? 'end' : 'start'}
              icon={isConnected ? X : Zap}
              buttonStyle={isConnected ? 'regular' : 'action'}
              onClick={
                isConnected ? disconnectConversation : connectConversation
              }
              
            />
            <UserComment isVisible={isModalVisible} onClose={handleClose} />
          </div>
        </div>
        <div className="content-right" style={{ display: 'none' }}>
          <div className="content-block map">
            <div className="content-block-title">get_weather()</div>
            <div className="content-block-title bottom">
              {marker?.location || 'not yet retrieved'}
              {!!marker?.temperature && (
                <>
                  <br />
                  🌡️ {marker.temperature.value} {marker.temperature.units}
                </>
              )}
              {!!marker?.wind_speed && (
                <>
                  {' '}
                  🍃 {marker.wind_speed.value} {marker.wind_speed.units}
                </>
              )}
            </div>
            <div className="content-block-body full">
              {coords && (
                <Map
                  center={[coords.lat, coords.lng]}
                  location={coords.location}
                />
              )}
            </div>
          </div>
          <div className="content-block kv">
            <div className="content-block-title">set_memory()</div>
            <div className="content-block-body content-kv">
              {JSON.stringify(memoryKv, null, 2)}
            </div>
          </div>
        </div>
      </div>
      <div className="footertext">
        {/* <div className="loveit" style={{cursor:"pointer", color: '#701a9a'}}>
          <div className='' onClick={userCommentOpen}>
            <u>Personalise it ...</u>
          </div>
        </div> */}
        <div>Powered by <a href='https://www.data.in/' target='_blank'>Data Ingenious global limited</a></div>
      </div>
    </div>
  );
}
